// extracted by mini-css-extract-plugin
module.exports = {"text":"style_text__1SbRS","logo":"style_logo__1b3jO"};